"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChronoUnit = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.ChronoUnit = {
    NANOS: 'NANOS',
    MICROS: 'MICROS',
    MILLIS: 'MILLIS',
    SECONDS: 'SECONDS',
    MINUTES: 'MINUTES',
    HOURS: 'HOURS',
    HALF_DAYS: 'HALF_DAYS',
    DAYS: 'DAYS',
    WEEKS: 'WEEKS',
    MONTHS: 'MONTHS',
    YEARS: 'YEARS',
    DECADES: 'DECADES',
    CENTURIES: 'CENTURIES',
    MILLENNIA: 'MILLENNIA',
    ERAS: 'ERAS',
    FOREVER: 'FOREVER'
};
//# sourceMappingURL=chrono-unit.js.map